import { Auth, API } from "aws-amplify";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";
import BaseAlphaUI from "../BaseAlphaUI";

class AuthService {
  /**
   * Check if user is logged in
   */
  async isAuthenticated(): Promise<boolean> {
    try {
      await Auth.currentSession();
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Sign out
   */
  async signOut(): Promise<void> {
    try {
      await Auth.signOut();
    } catch (e) { }
  }

  /**
   * Login using username and password
   * @param email The user's email
   * @param password Password submitted
   */
  async loginWithPassword(email: string, password: string): Promise<any> {
    const user = await Auth.signIn(email.toLowerCase(), password);
    return user;
  }

  /**
   * Sign up using username and password
   * @param email The user's email
   * @param password Password submitted
   */
  async signupWithPassword(email: string, password: string): Promise<any> {
    const user = await Auth.signUp({
      username: email.toLowerCase(),
      password,
    });
    return user;
  }

  async forgotPassword(username: string): Promise<any> {
    const response = await Auth.forgotPassword(username.toLowerCase());
    return response;
  }
  async forgotPasswordSubmit(
    username: string,
    code: string,
    password: string
  ): Promise<void> {
    await Auth.forgotPasswordSubmit(username.toLowerCase(), code, password);
  }

  async submitNewPassword(
    user: any,
    username: string,
    password: string
  ): Promise<void> {
    await Auth.completeNewPassword(user, password, {});
  }

  async submitCode(email: string, code: string): Promise<any> {
    const appName = BaseAlphaUI.getAppName();
    const inviteToken = window.localStorage.getItem(`${appName}InviteToken`);
    const inviteType = window.localStorage.getItem(`${appName}InviteType`);
    let clientMetadata = {
      method: "password"
    } as { [key: string]: string };
    if (inviteToken && inviteType) {
      clientMetadata = {
        ...clientMetadata,
        type: inviteType,
        token: inviteToken
      };
    }
    const verified = await Auth.confirmSignUp(email, code, {
      clientMetadata
    });
    window.localStorage.removeItem(`${appName}InviteToken`);
    window.localStorage.removeItem(`${appName}InviteType`);
    return verified;
  }
}

export default AuthService;
